import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { GlassPanel } from "./GlassPanel";
import { UserRound, TrendingUp, Wrench, Camera } from "lucide-react";

/** Admin-only per-installer performance table + drill-down. */
export default function InstallerAnalyticsPanel({ onSelect }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/analytics/installers").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, []);

  if (rows.length === 0) {
    return (
      <GlassPanel className="!p-6" delay={0.1}>
        <div className="text-label">Team</div>
        <h3 className="font-heading text-xl text-white mt-1 mb-3">Installer performance</h3>
        <div className="text-sm text-slate-500 italic">No installers yet.</div>
      </GlassPanel>
    );
  }

  return (
    <GlassPanel className="!p-6" delay={0.1}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-label flex items-center gap-2"><UserRound className="w-3 h-3" /> Team</div>
          <h3 className="font-heading text-xl text-white mt-1">Installer performance</h3>
        </div>
      </div>

      <div className="overflow-x-auto -mx-2">
        <table className="w-full text-sm" data-testid="installer-analytics-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-[0.2em] text-slate-500 text-left">
              <th className="px-2 py-3">Installer</th>
              <th className="px-2 py-3">Total</th>
              <th className="px-2 py-3">Done</th>
              <th className="px-2 py-3">Active</th>
              <th className="px-2 py-3">Completion</th>
              <th className="px-2 py-3">Photos</th>
              <th className="px-2 py-3 text-right"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`installer-row-${r.id}`} className="border-t border-white/[0.04]">
                <td className="px-2 py-3">
                  <div className="text-white">{r.name}</div>
                  <div className="text-[10px] text-slate-500">{r.email}</div>
                </td>
                <td className="px-2 py-3 text-white font-medium">{r.total_jobs}</td>
                <td className="px-2 py-3 text-emerald-300">{r.completed_jobs}</td>
                <td className="px-2 py-3 text-amber-300">{r.in_progress_jobs}</td>
                <td className="px-2 py-3">
                  <div className="flex items-center gap-2">
                    <div className="w-16 h-1.5 bg-white/5 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-blue-400 to-emerald-400" style={{ width: `${r.completion_rate}%` }} />
                    </div>
                    <span className="text-xs text-slate-300 tabular-nums">{r.completion_rate}%</span>
                  </div>
                </td>
                <td className="px-2 py-3 text-slate-300 flex items-center gap-1"><Camera className="w-3 h-3 text-slate-500" /> {r.photos_uploaded}</td>
                <td className="px-2 py-3 text-right">
                  <button
                    data-testid={`installer-view-${r.id}`}
                    onClick={() => onSelect?.(r)}
                    className="text-xs bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-3 py-1.5 text-slate-200"
                  >
                    View →
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </GlassPanel>
  );
}
